var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpdatesAppTile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0_4_Icons_MIB3 / 0_4_3_IconMaster / home / updates_app_tile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "47.0848673%",
    y1: "94.5440813%",
    x2: "68.2283406%",
    y2: "4.84246665%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEAEA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5B5B5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "16.1630824%",
    x2: "64.4362866%",
    y2: "168.160925%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B0F4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F448C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "56.4353898%",
    y1: "-11.5357919%",
    x2: "95.7648148%",
    y2: "239.056853%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B0F4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F448C",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "0_4_Icons_MIB3-/-0_4_3_IconMaster-/-home-/-updates_app_tile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "update_center",
    transform: "translate(6.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.4871796,7.17948719 C42.4594873,7.17948719 45.3258975,7.61564104 48.0612822,8.37128207 L46.9735898,0.721538463 C44.548718,0.253076924 42.0466668,9.23705556e-14 39.4871796,9.23705556e-14 C17.7135898,9.23705556e-14 -9.62785407e-13,17.7264102 -9.62785407e-13,39.5 C-9.62785407e-13,50.3858975 4.42794873,60.2448719 11.578718,67.3956412 L4.5,74.5 L26,74.5 L23.25,55.75 L16.6528205,62.3215386 C10.8033334,56.4702565 7.25,48.4061539 7.25,39.5 C7.25,21.6858974 21.673077,7.17948719 39.4871796,7.17948719 Z",
    id: "Arrow_white---Fill",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4871796,1 C41.7366351,1 43.9405602,1.20066316 46.0848641,1.57486851 L46.0848641,1.57486851 L46.8612923,7.03549041 C44.4879186,6.48724727 42.0249291,6.17948719 39.4871796,6.17948719 C30.3094173,6.17948719 22.0044093,9.91355682 15.9915784,15.9419309 C9.97195781,21.9771122 6.25,30.3117781 6.25,39.5 C6.25,49.0406136 10.2063609,57.6431605 16.6619636,63.723899 L16.6619636,63.723899 L22.548765,57.8599775 L24.842635,73.5 L6.90805463,73.5 L13.0006853,67.3853003 C5.61266434,60.3666594 1,50.4683144 1,39.5 C1,28.8879162 5.31743937,19.2624339 12.287456,12.2901543 C19.2562184,5.3191293 28.8769932,1 39.4871796,1 Z",
    id: "Arrow_white---Border",
    strokeOpacity: 0.332167832,
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3956412,11.578718 L74.5,4.5 L53,4.5 L55.75,23.25 L62.3215386,16.6546154 C68.1710258,22.5041026 71.75,30.5938461 71.75,39.5 C71.75,57.3141026 57.3012822,71.7948719 39.4871796,71.7948719 C36.5148719,71.7948719 33.6484616,71.3587181 30.913077,70.6030771 L32.0007693,78.2528207 C34.4256411,78.7212822 36.9276924,78.9743591 39.4871796,78.9743591 C61.2607694,78.9743591 79,61.2735898 79,39.5 C79,28.6141025 74.5464104,18.7294872 67.3956412,11.578718 Z",
    id: "Arrow_blue-_-Fill",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0796006,5.5 L65.9710166,11.586537 C73.3589694,18.6036977 78,28.529965 78,39.5 C78,50.108289 73.6791826,59.7243582 66.7071502,66.6896042 C59.7313526,73.6586116 50.1011608,77.9743591 39.4871796,77.9743591 C37.237724,77.9743591 35.033799,77.773696 32.889495,77.3994906 L32.889495,77.3994906 L32.1130668,71.9388687 C34.4864405,72.4871119 36.94943,72.7948719 39.4871796,72.7948719 C48.6681602,72.7948719 56.9822826,69.0645189 63.0019872,63.038834 C69.0243054,57.010533 72.75,48.6850036 72.75,39.5 C72.75,29.9583616 68.7644961,21.3262406 62.3095813,15.2498344 L62.3095813,15.2498344 L56.4498819,21.1307968 L54.157365,5.5 L72.0796006,5.5 Z",
    id: "Arrow_blue-_-Border",
    stroke: "url(#linearGradient-3)",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdatesAppTile);
export default __webpack_public_path__ + "static/media/updates_app_tile.31758711ca4e7f7d2a71559d63864e2f.svg";
export { ForwardRef as ReactComponent };